module.exports = __webpack_public_path__ + "static/media/Logo2.bc2a8847.png";